module.exports = __webpack_public_path__ + "media/spa/flow_step_01-0ed1fc93.svg";